import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "disabled", "variant"];
import React from 'react';
import PropTypes from 'prop-types';
import withTheme from '../../theme/withTheme';
import { DayButton } from './styles';
var Day = function Day(_ref) {
  var children = _ref.children,
    disabled = _ref.disabled,
    variant = _ref.variant,
    other = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(DayButton, _extends({
    tabIndex: disabled ? -1 : 0,
    disabled: disabled,
    variant: disabled ? 'disabled' : variant
  }, other), children);
};
Day.defaultProps = {
  disabled: false,
  variant: 'default'
};
process.env.NODE_ENV !== "production" ? Day.propTypes = {
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf(['default', 'disabled', 'hidden', 'selected', 'current'])
} : void 0;
export default withTheme(Day);